import { render, staticRenderFns } from "./Render.vue?vue&type=template&id=0e38d730&scoped=true"
import script from "./Render.vue?vue&type=script&lang=js"
export * from "./Render.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e38d730",
  null
  
)

export default component.exports